import { css } from "@emotion/react";

import { Typography, useThemeProps } from "../../wsui/base";

import useFormField from "./useFormField";

export default function FormFieldError(props) {
  props = useThemeProps({ props, name: "FormFieldError" });
  let { as: Component = "div", color = "error.600", ...restProps } = props;

  const { meta, id } = useFormField();

  return (
    <Component
      id={`${id}-errors`}
      aria-live="assertive"
      css={css`
        position: ${meta.error && meta.touched ? null : "absolute"};
      `}
      {...restProps}
    >
      {meta.error && meta.touched && (
        <Typography variant="description" color={color}>
          {meta.error}
        </Typography>
      )}
    </Component>
  );
}
